// Misc
import React, { PureComponent, Fragment, Children, cloneElement } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import uniqueId from 'lodash/uniqueId'
import { withStyles } from '@material-ui/core/styles'

// Actions
import connectActions from 'utils/connectActions'
import { uploadImage } from 'actions/uploader'

// Atoms
import IconButton from '@material-ui/core/IconButton'
import { AppProgressActivator } from 'atoms/AppProgress'
import Menu from 'atoms/Menu'
import MenuItem from '@material-ui/core/MenuItem'

// Icons
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera'

// Styles
const styles = theme => ({
  button: {
    color: theme.palette.secondary.contrastText,
  },
  fileInput: {
    display: 'none'
  }
})

const mapActionsToProps = {
  uploadImageAction: uploadImage
}

export default
@connectActions(mapActionsToProps)
@withStyles(styles)
class ImageInput extends PureComponent {
  static propTypes = {
    className: PropTypes.any,
    onLoading: PropTypes.func,
    onChange: PropTypes.func,
    classes: PropTypes.object.isRequired,
    uploadImageAction: PropTypes.object.isRequired,
    children: PropTypes.any,
  }

  static defaultProps = {
    onLoading: () => {},
    onChange: () => {},
  }

  constructor() {
    super()
    this.id = uniqueId('ImageInput')
    this.state = {
      anchorEl: null
    }
  }

  handleFileInputChange = async () => {
    const { uploadImageAction, onLoading, onChange } = this.props
    const file = this.fileInput.files[0]
    if (file && !uploadImageAction.isPending) {
      onLoading()
      const { url } = await uploadImageAction.run({
        params: [file],
      })
      onChange(url)
    }
  }

  handleMenuClose = () => {
    this.setState({ anchorEl: null })
  }

  handleButtonClick = (ev) => {
    this.setState({ anchorEl: ev.currentTarget })
  }

  handleChildClick = child => (ev) => {
    this.setState({ anchorEl: null }, () => {
      const { onClick } = child.props
      if (onClick) onClick(ev)
    })
  }

  fileInputRef = (fileInput) => {
    this.fileInput = fileInput
  }

  renderChildren() {
    const { children } = this.props
    return Children.map(children, child => cloneElement(child, {
      onClick: this.handleChildClick(child)
    }))
  }

  render() {
    const { classes, uploadImageAction, className, children } = this.props
    const { anchorEl } = this.state
    const cx = classNames(classes.button, className)

    const buttonProps = children ? {
      onClick: this.handleButtonClick
    } : {
      component: 'label',
      htmlFor: this.id,
    }

    return (
      <Fragment>
        { uploadImageAction.isPending && <AppProgressActivator /> }
        <Menu
          open={!!anchorEl}
          anchorEl={anchorEl}
          onClose={this.handleMenuClose}
        >
          <MenuItem
            component="label"
            htmlFor={this.id}
            onClick={this.handleMenuClose}
          >
            Upload image
          </MenuItem>
          { this.renderChildren() }
        </Menu>
        <input
          type="file"
          id={this.id}
          accept="image/*"
          ref={this.fileInputRef}
          className={classes.fileInput}
          onChange={this.handleFileInputChange}
        />
        <IconButton className={cx} {...buttonProps}>
          <PhotoCameraIcon />
        </IconButton>
      </Fragment>
    )
  }
}
